import { useMemo } from 'react';

import { mergeRestaurantData } from 'features/store/utils';

import { IRestaurant } from '@rbi-ctg/store';
import { InputMaybe, useGetRestaurantQuery } from 'generated/graphql-gateway';
import { IRestaurantFilter, useGetRestaurantsQuery } from 'generated/sanity-graphql';

export const useGetStoreDetails = (id: string | undefined) => {
  let filter: InputMaybe<IRestaurantFilter> = {
    _id: id,
  };

  if (!isNaN(Number(id))) {
    filter = {
      number: id,
    };
  }

  const getRestaurantFromSanity = useGetRestaurantsQuery({
    skip: !id,
    variables: {
      filter,
      limit: 1,
    },
  });
  const secondQueryVariables = useMemo(
    () => ({
      storeId: getRestaurantFromSanity?.data?.allRestaurants?.[0]?.number,
    }),
    [getRestaurantFromSanity]
  );
  const getRestaurantFromRBI = useGetRestaurantQuery({
    fetchPolicy: 'cache-and-network',
    skip: !secondQueryVariables.storeId,
    variables: secondQueryVariables,
  });

  const { restaurant, error, loading } = useMemo(
    () => ({
      restaurant:
        getRestaurantFromRBI.data &&
        getRestaurantFromSanity.data &&
        getRestaurantFromSanity.data.allRestaurants.length !== 0
          ? mergeRestaurantData({
              rbiRestaurant: (getRestaurantFromRBI.data.restaurant as unknown) as IRestaurant,
              sanityStore: getRestaurantFromSanity.data.allRestaurants[0] as any,
            })
          : undefined,
      error: getRestaurantFromRBI.error || getRestaurantFromSanity.error || undefined,
      loading: getRestaurantFromRBI.loading || getRestaurantFromSanity.loading,
    }),
    [getRestaurantFromRBI, getRestaurantFromSanity]
  );

  return { restaurant, error, loading };
};
